import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'glamorous'

export default class MyComponent extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func
  }
  static defaultProps = {
    onClick: () => {}
  }

  // Store if mouse is down and if user is dragging, to differentiate
  // between clicks and drags.
  isDown = false
  cursorPos = 0
  cursorDelta = 0

  handleMove = event => {
    const e = event.touches ? event.touches[0] : event

    if (this.isDown) {
      const tmpDelta = e.clientX - this.cursorPos
      this.cursorPos = e.clientX
      this.cursorDelta += tmpDelta
    }
  }

  handleDown = event => {
    const e = event.touches ? event.touches[0] : event

    this.cursorPos = e.clientX
    this.isDown = true
  }

  handleUp = () => {
    this.isDown = false
  }

  handleClick = event => {
    // When the user is dragging a card, the click should not be executed
    if (Math.abs(this.cursorDelta) > 30) {
      this.cursorDelta = 0
      return
    }

    this.cursorDelta = 0
    this.props.onClick(event)
  }

  render() {
    return (
      <Button
        display="block"
        width="50%"
        height="100%"
        outline="none"
        border={0}
        padding={0}
        background="transparent"
        WebkitTapHighlightColor="transparent"
        onClick={this.handleClick}
        onMouseDown={this.handleDown}
        onMouseUp={this.handleUp}
        onMouseMove={this.handleMove}
        onTouchStart={this.handleDown}
        onTouchEnd={this.handleUp}
        onTouchMove={this.handleMove}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/ClickArea.js